// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_yKv","cls2":"AuthorsCard-cls2_tno AuthorsCard-cls1_yKv","margin":"AuthorsCard-margin_Are"};